import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
  writeBatch
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication, Firestore, and Storage
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Initialize Google Auth Provider
const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });

// Export Google Sign-in function
const signInWithGoogle = () => signInWithPopup(auth, provider);



// Initialize database with system configuration if needed
const initializeDatabase = async () => {
  // Create a flag in localStorage to prevent multiple initializations in the same session
  if (localStorage.getItem('dbInitialized') === 'true') {
    console.log('Database already initialized in this session, skipping');
    return;
  }

  try {
    console.log('Initializing database with system configuration...');

    // Create system_config document
    const configRef = doc(db, 'system_config', 'general');
    try {
      await setDoc(configRef, {
        visitorCheckInHours: 24,
        maxVisitorsPerDay: 50,
        requireApproval: true,
        notificationsEnabled: true,
        maintenanceMode: false,
        lastUpdated: serverTimestamp(),
        updatedBy: 'system',
        initialized: true
      }, { merge: true });
      console.log('Created/updated system_config document');
    } catch (error) {
      console.error('Error creating system_config:', error);
    }

    // Set the flag to prevent re-initialization
    localStorage.setItem('dbInitialized', 'true');
    console.log('Database initialization completed');
  } catch (error) {
    console.error('Error initializing database:', error);
  }
};

export { auth, db, storage, signInWithGoogle, initializeDatabase };
